import React, { useState } from "react";
import axios from "axios";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useNavigate, Link } from "react-router-dom";
import "./Register.css"; // 🧹 Clean separate CSS file

const Register = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    username: "",
    email: "",
    password: "",
    confirmPassword: "",
  });

  const [message, setMessage] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.password !== formData.confirmPassword) {
      setMessage("❌ Passwords do not match.");
      return;
    }

    try {
      setLoading(true);
      const { username, email, password } = formData;
      const res = await axios.post(
        "https://bookmatchup.onrender.com/api/auth/register",
        {
          username,
          email,
          password,
          authProvider: "local",
        }
      );

      setMessage(`✅ ${res.data.alert || "Registration successful!"}`);

      setFormData({
        username: "",
        email: "",
        password: "",
        confirmPassword: "",
      });

      setTimeout(() => {
        navigate("/login");
      }, 4000);
    } catch (error) {
      setMessage(
        `❌ ${error.response?.data?.message || "Something went wrong"}`
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="register-container">
      <h1 className="register-title">Register</h1>

      {message && (
        <div
          className={`message-box ${
            message.startsWith("✅") ? "success" : "error"
          }`}
        >
          <p>{message}</p>
          {message.startsWith("✅") && <p>Redirecting to login...</p>}
        </div>
      )}

      <form className="register-form" onSubmit={handleSubmit}>
        <div className="input-container">
          <label>Username</label>
          <input
            name="username"
            type="text"
            placeholder="Enter username"
            value={formData.username}
            onChange={handleChange}
            required
            className="register-input"
          />
        </div>

        <div className="input-container">
          <label>Email</label>
          <input
            name="email"
            type="email"
            placeholder="Enter email"
            value={formData.email}
            onChange={handleChange}
            required
            className="register-input"
          />
        </div>

        <div className="input-container">
          <label>Password</label>
          <div className="password-wrapper">
            <input
              name="password"
              type={showPassword ? "text" : "password"}
              placeholder="Enter password"
              value={formData.password}
              onChange={handleChange}
              required
              className="register-input"
            />
            <span
              className="toggle-password"
              onClick={() => setShowPassword((prev) => !prev)}
            >
              {showPassword ? (
                <FaEyeSlash className="password-icon" />
              ) : (
                <FaEye className="password-icon" />
              )}
            </span>
          </div>
        </div>

        <div className="input-container">
          <label>Confirm Password</label>
          <div className="password-wrapper">
            <input
              name="confirmPassword"
              type={showConfirmPassword ? "text" : "password"}
              placeholder="Confirm password"
              value={formData.confirmPassword}
              onChange={handleChange}
              required
              className="register-input"
            />
            <span
              className="toggle-password"
              onClick={() => setShowConfirmPassword((prev) => !prev)}
            >
              {showConfirmPassword ? (
                <FaEyeSlash className="password-icon" />
              ) : (
                <FaEye className="password-icon" />
              )}
            </span>
          </div>
        </div>

        <button type="submit" className="register-button" disabled={loading}>
          {loading ? "Registering..." : "Register"}
        </button>
      </form>

      <p className="login-note">
        Already have an account?{" "}
        <Link to="/login" className="link">
          Login here
        </Link>
        .
      </p>
    </div>
  );
};

export default Register;
